export default __webpack_public_path__ + "static/media/increase2.e3186811.png";